import { render, staticRenderFns } from "./aboutAudience.vue?vue&type=template&id=9cb21fea&scoped=true&"
import script from "./aboutAudience.vue?vue&type=script&lang=js&"
export * from "./aboutAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb21fea",
  null
  
)

export default component.exports